<div class="ingredient-layout">
  <div class="ingredients-cards background-grey">
    <h3 class="form-field-maxi space-v-s" id="RecipesModifyMoreInfosSemanticLbl">
      {{ 'SEMANTIZATION.BLOCK_INGREDIENTS.SEMANTIZATION' | translate }}
    </h3>
    <mat-card class="mat-card" *ngFor="let ingredient of ingredientList; let index = index">
      <mat-card-header class="mat-card-header" [ngClass]="{ 'main-ingredient': ingredient.isMainIngredient }">
        <mat-card-title class="mat-card-title">
          <strong id="RecipesModifyMoreInfosSemanticIngredientLbl{{ index }}">{{ ingredient.foodLabel }}</strong>
          <small *ngIf="ingredient.isMainIngredient">{{ 'SEMANTIZATION.BLOCK_INGREDIENTS.TABLE.MAIN_INGREDIENT' | translate }}</small>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content class="mat-card-content">
        <div class="inline-display" id="RecipesModifyMoreInfosSemanticQuantityLbl{{ index }}">
          <span title="{{ 'SEMANTIZATION.BLOCK_INGREDIENTS.TABLE.QUANTITY' | translate }}" *ngIf="ingredient.quantity"
            >{{ ingredient.quantity }}
          </span>
          <span title="{{ 'SEMANTIZATION.BLOCK_INGREDIENTS.TABLE.UNIT' | translate }}" *ngIf="ingredient.unitLabel">
            {{ ingredient.unitLabel }}
          </span>
        </div>
        <span title="{{ 'SEMANTIZATION.BLOCK_INGREDIENTS.TABLE.FOOD' | translate }}"> {{ ingredient.foodLabel }}</span>
      </mat-card-content>
      <mat-card-footer class="mat-card-footer">
        <small>
          <strong *ngIf="ingredient.weight?.quantity || ingredient.weightRatio"
            >{{ 'SEMANTIZATION.BLOCK_INGREDIENTS.TABLE.WEIGHT' | translate }} :</strong
          >
          <span *ngIf="ingredient.weight?.quantity"> {{ ingredient.weight.quantity }} g</span>
        </small>
      </mat-card-footer>
    </mat-card>
    <h4 *ngIf="!ingredientList.length">
      {{ 'SEMANTIZATION.BLOCK_INGREDIENTS.NO_DATA' | translate }}
    </h4>
  </div>

  <div class="ingredient-list background-grey">
    <h3 class="space-v-s" id="RecipesModifyMoreInfosSemanticAllIngredientsLbl">
      {{ 'SEMANTIZATION.BLOCK_INGREDIENTS.TITLE' | translate }}
    </h3>
    <ul id="RecipesModifyMoreInfosSemanticAllIngredientDescLst">
      <li *ngFor="let ingredient of variant?.ingredients | sortBy : 'absoluteOrder'">
        {{ ingredient.applicationDescription }}
      </li>
    </ul>
  </div>
</div>
